"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendEmailDto = exports.emailType = void 0;
var emailType;
(function (emailType) {
    emailType["TEAMS_generic"] = "TEAMS_generic";
    emailType["TEAMS_signin"] = "TEAMS_signin";
    emailType["TEAMS_email_validation"] = "TEAMS_email_validation";
    emailType["TEAMS_forgot_password"] = "TEAMS_forgot_password";
    emailType["TEAMS_interest_in_eventr"] = "TEAMS_interest_in_eventr";
    emailType["TEAMS_instance_created"] = "TEAMS_instance_created";
    emailType["TEAMS_itin_request_access"] = "TEAMS_itin_request_access";
    emailType["TEAMS_team_request_access"] = "TEAMS_team_request_access";
    emailType["TEAMS_itin_access_approved"] = "TEAMS_itin_access_approved";
    emailType["TEAMS_team_access_approved"] = "TEAMS_team_access_approved";
    emailType["TEAMS_team_access_request_admin"] = "TEAMS_team_access_request_admin";
    emailType["TEAMS_itin_access_request_admin"] = "TEAMS_itin_access_request_admin";
    emailType["TEAMS_invite_backoffice"] = "TEAMS_invite_backoffice";
    emailType["TEAMS_invite_team"] = "TEAMS_invite_team";
    emailType["TEAMS_invite_itin"] = "TEAMS_invite_itin";
})(emailType || (exports.emailType = emailType = {}));
class SendEmailDto {
    emailType;
    subject;
    sendingTo;
    firstNames;
    lastNames;
    link;
    teamCode;
    teamName;
    username;
    password;
    staffPerson;
    invitationPerson;
    genericMessage;
    invitingUserFirstName;
    invitingUsersMessage;
    linkToUpdateDetails;
}
exports.SendEmailDto = SendEmailDto;
